import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=480d01bd&scoped=true"
import script from "./CreateQuestion.vue?vue&type=script&lang=js"
export * from "./CreateQuestion.vue?vue&type=script&lang=js"
import style0 from "./CreateQuestion.vue?vue&type=style&index=0&id=480d01bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d01bd",
  null
  
)

export default component.exports